import React from 'react';
import { toast } from 'react-toastify';

import DeleteConfirmModal from 'components/DeleteConfirmModal';
import { useHomeScreenContext } from 'layouts/HomeScreenLayout/contexts/HomeScreenContext';
import PropTypes from 'prop-types';
import { formatCurrency, toastStyle } from 'utils/helper';
import { useQueryClient } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';

const DeleteFringes = props => {
  const {
    refetchFringe,
    showDeleteFringe,
    refetchTabs,

    delData,
    hideDeleteFringeModal,
    deleteFringeMutation,
    frindgeDetailsForModal,
    hasEditAccess,
  } = useHomeScreenContext();
  const queryClient = useQueryClient();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const instanceType = queryParams.get('type') || 'budget';
  const handleCancel = () => {
    // hideDeleteMultiBudgetModal();
    hideDeleteFringeModal();
  };

  const getDeleteItemCount = () => {
    return delData?.reduce((i, n) => {
      return i + 1;
    }, 0);
  };
  const deleteMessage = (() => {
    const isSingle = delData?.length === 1;
    const hasLines = frindgeDetailsForModal?.data?.some(
      group => group?.lines?.length > 0
    );

    if (isSingle && instanceType === 'budget') {
      const group = frindgeDetailsForModal?.data?.[0];
      const name = group?.full_name || delData?.[0]?.full_name || 'this fringe';

      if (group?.lines?.length > 0) {
        return (
          <div style={{ textAlign: 'left' }}>
            <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>
              ⚠️ Warning! This fringe is currently applied to:
            </p>
            <ul
              style={{
                listStyleType: 'disc',
                paddingLeft: '1.2rem',
                textAlign: 'left',
                display: 'inline-block',
              }}
            >
              {group.lines.map((line, index) => (
                <li key={index}>{line}</li>
              ))}
            </ul>
            <p
              style={{
                marginTop: '12px',
                fontWeight: 500,
                marginBottom: '8px',
                textAlign: 'left',
              }}
            >
              Totaling: <strong>{formatCurrency(group.updated_total)}</strong>.
            </p>
            <p style={{ marginTop: '8px' }}>
              Deleting it will remove it from all of those line items and reduce
              the budget by that amount.
            </p>
          </div>
        );
      } else {
        return (
          <p>
            Are you sure you want to delete <strong>{name}</strong>?
          </p>
        );
      }
    }

    if (!isSingle && hasLines) {
      return (
        <div style={{ textAlign: 'left' }}>
          <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>
            ⚠️ Warning! The following fringes are currently applied to line
            items:
          </p>
          {frindgeDetailsForModal?.data
            ?.filter(group => group?.lines?.length > 0)
            .map((group, groupIndex) => (
              <div key={groupIndex} style={{ marginBottom: '16px' }}>
                <p style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                  Fringe: {group.name || `Fringe ${groupIndex + 1}`}
                </p>
                <ul
                  style={{
                    listStyleType: 'disc',
                    paddingLeft: '1.2rem',
                    textAlign: 'left',
                    display: 'inline-block',
                  }}
                >
                  {group?.lines?.map((line, lineIndex) => (
                    <li key={lineIndex}>{line}</li>
                  ))}
                </ul>
                <p
                  style={{
                    marginTop: '8px',
                    fontWeight: 500,
                    marginBottom: '8px',
                    textAlign: 'left',
                  }}
                >
                  Totaling:{' '}
                  <strong>{formatCurrency(group.updated_total)}</strong>.
                </p>
              </div>
            ))}
          <p style={{ marginTop: '8px' }}>
            Deleting these fringes will remove them from all of the above line
            items and reduce the budget by the respective amounts.
          </p>
        </div>
      );
    }

    const fringeCount = getDeleteItemCount();
    return (
      <p>
        Are you sure you want to delete {fringeCount}{' '}
        {fringeCount === 1 ? 'fringe' : 'fringes'}?
      </p>
    );
  })();

  const handleDeleteBudget = async () => {
    const fringeIds = [];
    for (let i = 0; i < delData?.length; i++) {
      const id = Number(delData[i]?.id);
      fringeIds.push(id);
    }
    try {
      await deleteFringeMutation.mutateAsync({
        fringe_Ids: fringeIds,
      });
      toast.dismiss();
      toast.success(
        `Fringe "${delData[0]?.full_name}" deleted successfully`,
        toastStyle
      );
      queryClient.invalidateQueries({
        predicate: query => query.queryKey[0] === 'get-fringe-details',
      });
      handleCancel();
      refetchFringe?.();
      refetchTabs();
      props?.onFringeCreated?.();
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.non_field_errors?.[0];
      toast.dismiss();
      toast.error(
        message ||
          `An error occurred while deleting the budget "${delData[0]?.full_name}". Please try again later`,
        toastStyle
      );
    }
  };

  return (
    <DeleteConfirmModal
      showModal={showDeleteFringe}
      handleOnClose={handleCancel}
      onCancel={handleCancel}
      onConfirm={handleDeleteBudget}
      confirmText={deleteMessage}
      confirmLabel="Delete"
      disabled={instanceType === 'budget' && !hasEditAccess()}
    />
  );
};
DeleteFringes.propTypes = {
  refetch: PropTypes.func.isRequired,
  onFringeCreated: PropTypes.func.isRequired,
};

export default DeleteFringes;
